module.exports = __webpack_public_path__ + "img/low-liquidity-disable-dark.a91467c1.svg";